// extracted by mini-css-extract-plugin
export default {"bannerContainer":"banners_bannerContainer__CYr8u","textbanner":"banners_textbanner__3z3JZ","text":"banners_text__d4bph","image":"banners_image__p4C1N"};